// extracted by mini-css-extract-plugin
module.exports = {"container":"DeviceDetail_container__dQhnq"};